import { render, staticRenderFns } from "./footer-links.vue?vue&type=template&id=170f8208&scoped=true&"
import script from "./footer-links.vue?vue&type=script&lang=js&"
export * from "./footer-links.vue?vue&type=script&lang=js&"
import style0 from "./footer-links.vue?vue&type=style&index=0&id=170f8208&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f8208",
  null
  
)

export default component.exports